import { useEffect, useState } from "react";
import DataTable, { TableColumn } from "react-data-table-component";
import { postAPI, getAPI, deleteAPI, putAPI } from "../../Services/APIservices";
import { SkeletonLoader } from "../../Components/SkeletonLoader/SkeletonLoader";
import { DataRow } from "./model";
import {
  Accordian,
  Button,
  Input,
  toastEmitter,
  Tooltip,
  Typography,
} from "@anchor/react-components/dist/lib/components";
import StatusBadge from "../../Components/StatusBage/StatusBadge";
import CreateRequest from "./AddOnPages/CreateRequest";
import { RedirectionCase } from "./AddOnPages/RedirectionCase";
import "./RequestPage.scss";
import Filters from "./Filters";
import EditDtcoRequest from "./AddOnPages/EditDtcoRequest";
import { appRoles } from "../../utils/Constants";
import { fetchDateFormat } from "../../utils/CustomDateTime";
import { excelDownload } from "../../utils/excelDownload";
import moment from "moment";
import { Console } from "console";
import ConfirmModal from "../../Components/ConfirmationModel/ConfirmModal";
import { useForm, Controller } from "react-hook-form";
interface IPROPS {
  isCharter?: boolean;
}

const RequestPage = ({ isCharter }: IPROPS) => {
  const { control } = useForm();
  const [rquestTableData, setRquestTableData] = useState([]);
  const [storeTableData, setStoreTableData] = useState([]); // to store the original data
  const [isTableLoader, setIsTableLoader] = useState(false);
  const mainPayload = {
    IsDeploymentUserView: !isCharter ? true : false,
  };

  const [filterData, setFilterData] = useState({});
  const [isCreateRequestModalOpen, setIsCreateRequestModalOpen] =
    useState(false);
  const [editModal, setEditModal] = useState(false);
  const [editRow, setEditRow] = useState<any>();
  const [isClearFilter, setIsClearFilter] = useState(false);
  const [actionType, setActionType] = useState("");

  const userRole = sessionStorage.getItem("userRole");
  const checkRoleForActionButton = userRole === appRoles.DeploymentUser || userRole === appRoles.CharteringManager;
  const [accordion, setAccordian] = useState({
    filter: true,
  });

  const [showConfirm, setShowConfirm] = useState(false);
  const [modalConfig, setModalConfig] = useState({
    title: "",
    message: "",
    onConfirm: () => {},
  });
  const [currentPayload, setCurrentPayload] = useState({});

  const getRquestDetails = async (payload: object) => {
    setIsTableLoader(true);
    const response = await postAPI(`dtco-api/dtco/GetAllDTCORequests`, payload);
    const tableResponse = response;

    setRquestTableData(tableResponse);
    setStoreTableData(tableResponse);
    setIsTableLoader(false);
    setCurrentPayload(payload);
  };

  const CaseWithdrawnApi = async (id: number) => {
    try {
      const response =   await getAPI(
        `dtco-api/Dtco/HandleDtcoRequestWithdrawal/${id}`
      );


      if (response > 0) {
        const successMessage = `Case Withdrawal successfully`
        toastEmitter(
          { className: "customClassName", title: successMessage },
          { type: "success" }
        );
      } else
      {
        toastEmitter(
          { className: "customClassName", title: "Already actioned. Withdrawal not allowed" },
          { type: "error" }
        );
      }

    } catch (error) {
      toastEmitter(
        { className: "customClassName", title: "Failed to withdraw case. Please try again." },
        { type: "error" }
      );
    }
  };
  
  const handleSearch = (searchText: string) => {
    if (searchText.trim() === "") {
      setRquestTableData(storeTableData);
    } else {
      const filtered = storeTableData.filter((item: any) =>
        item.requestName?.toLowerCase().includes(searchText.toLowerCase())
      );
      setRquestTableData(filtered);
    }
  };

  const DeleteCaseWithdrawn = async (id: number) => {
   try {
     const response =   await deleteAPI(
       `dtco-api/Dtco/DeleteDTCORequest/${id}`
     );

     
     if (response > 0) {
       const successMessage = `Case Withdrawal Deleted successfully`
       toastEmitter(
         { className: "customClassName", title: successMessage },
         { type: "success" }
       );
     }

   } catch (error) {
     toastEmitter(
      { className: "customClassName", title: "Failed to delete case. Please try again." },
      { type: "error" }
    );

   }
 };


  const editButtonHandler = (row: any) => {
    return (
      <div className="action-btns">{
        
        (userRole === appRoles.DeploymentUser) && !isCharter && (
          <>
          <Button

            appearance="default"
            className="xs-btn"
            id="primary"
            icon="pencil"
            justifyItems="center"
            // label={isCharter ? "" : "Edit"}
            name="Edit"
            disabled={(row.statusName === "Completed") ? true : false}
            fit="small"
            iconPosition="right"
            onClick={() => {
              setEditModal(true);
              setEditRow(row);
              setActionType("Edit");
            } }
            variant="outlined" /><Button
              className="xs-btn"
              appearance="default"
              id="copy-request"
              icon="copy"
              justifyItems="center"
              // label={isCharter ? "" : "Copy"}
              name="Edit"
              disabled={row.statusName === "Completed" ? true : false}
              fit="small"
              iconPosition="right"
              onClick={() => {
                setEditModal(true);
                setEditRow(row);
                setActionType("Copy");
              } }
              variant="outlined" />
              
            {row.allowWithdrawal === true && (
            <><Button
                appearance="default"
                className="xs-btn"
                id="primary"
                icon="arrow-clockwise-times"
                justifyItems="center"
                name="Withdrawal"
                fit="small"
                iconPosition="right"
                onClick={() => {
                  setModalConfig({
                    title: "Withdrawal Confirmation",
                    message: "Are you sure you want to withdraw the case?",
                    onConfirm: async () => {
                      await CaseWithdrawnApi(row.id);
                      setShowConfirm(false);
                      await getRquestDetails(currentPayload); // Refresh data
                    },
                  });
                  setShowConfirm(true);
                } }
                variant="outlined" />
                </>
          )}

        {row.statusName === "Case Withdrawn" && (
                    <><Button
                appearance="default"
                className="xs-btn"
                id="primary"
                icon="trash"
                justifyItems="center"
                name="DeleteWithdrawal"
                fit="small"
                iconPosition="right"
                onClick={() => {
                  setModalConfig({
                    title: "Delete Confirmation",
                    message: "Are you sure you want to delete the withdrawn case?",
                    onConfirm: async () => {
                     await DeleteCaseWithdrawn(row.id);
                      setShowConfirm(false);
                      await getRquestDetails(currentPayload); 
                    },
                  });
                  setShowConfirm(true);
                } }
                variant="outlined" />
                  </>
                  
                  )}

          <ConfirmModal
            visible={showConfirm}
            title={modalConfig.title}
            message={modalConfig.message}
            onCancel={() => setShowConfirm(false)}
            onConfirm={modalConfig.onConfirm}
          />

              </>
      )
      }

        {(userRole === appRoles.CharteringManager || userRole === appRoles.DeploymentUser) && isCharter && (
          <>
            <Button
              appearance="default"
              id="primary"
              icon="pencil"
              justifyItems="center"
              label={isCharter ? "" : "Edit"}
              name="Edit"
              disabled={(row.statusName === "Completed" || row.statusName === "Closed") ? true : false}
              fit="small"
              iconPosition="right"
              onClick={() => {
                setEditModal(true);
                setEditRow(row);
                setActionType("Edit");
              }}
              variant="outlined"
            />
            <Button
              className="xs-btn"
              appearance="default"
              id="copy-request"
              icon="copy"
              justifyItems="center"
              label={isCharter ? "" : "Copy"}
              name="Edit"
              disabled={row.statusName === "Completed" ? true : false}
              fit="small"
              iconPosition="right"
              onClick={() => {
                setEditModal(true);
                setEditRow(row);
                setActionType("Copy");
              }}
              variant="outlined"
            />
          </>

        )}
      </div>
    );
  };

  const getDTCORequestFilters = async () => {
    const response = await getAPI(
      `dtco-api/dtco/GetDTCORequestFilters/${!isCharter ? true : false}`
    );
    setFilterData(response);
  };

  useEffect(() => {
    getRquestDetails(mainPayload);
    getDTCORequestFilters();
  }, []);
  //helper function for filtering
  const filterInKeysAndValues = (
    values: string[],
    keys: string[],
    request: any
  ) => {

  const isDateRangeFilter = keys.includes("requestSubmittedToTradeOwner") || keys.includes("requestExecutedOn");
  
  return isDateRangeFilter
    ? values.length === 0 ||
      (request[keys[0]] >= values[0] &&
        (values[1] === "" || request[keys[0]] <= values[1]))
    : values.length === 0 ||
      keys.some((key) => values.includes(request[key]));
};

  const filterRes = (data: any, filterDataValues: Array<Object>): any => {
    return data?.filter((eachRequest: any) => {
      let isRowValid = true;
      filterDataValues?.forEach((selectedValue: any) => {
        if (selectedValue?.value?.length > 0) {
          const matchFilter = filterInKeysAndValues(
            selectedValue?.value,
            selectedValue?.key,
            eachRequest
          );
          if (!matchFilter) {
            isRowValid = false;
          }
        }
      });
      return isRowValid;
    });
  };
  const ClearFilters = () => {
    setRquestTableData(storeTableData);
  };
  const getFilteredRequestDetails = (filters: any) => {

    console.log("Filters applied:", filters); // Debug log to check filters
    const payLoad = {
      dtcoRequestTypes: filters?.dtcoRequestTypes?.map(
        (item: any) => item?.label
      ),
      statuses: filters?.statuses?.map((item: any) => item?.label),
      requestCreatedUsers: filters?.requestCreatedUsers?.map(
        (item: any) => item?.label
      ),
      dtcoCategorizations: filters?.driverCategories?.map(
        (item: any) => item?.label
      ),
      executedData: filters?.executedData?.map((item: any) => item?.label),
      requestSubmittedToTradeOwner:
        filters?.requestSubmittedToTradeOwner[0] ||
          filters?.requestSubmittedToTradeOwner[1]
          ? filters?.requestSubmittedToTradeOwner
          : ["", ""],
      executionPeriod:
      filters?.executionPeriod && (filters?.executionPeriod[0] || filters?.executionPeriod[1])
        ? filters?.executionPeriod
        : ["", ""],

    };

    const filterArray = [
    { value: payLoad?.dtcoRequestTypes, key: ["dtcoTypeName"] },
    { value: payLoad?.requestCreatedUsers, key: ["createdBy"] },
    { value: payLoad?.statuses, key: ["statusName"] },
    { value: payLoad?.dtcoCategorizations, key: ["dtcoCategoryName"] },
    { value: payLoad?.executedData, key: ["requestExecuted"] },
    {
      value: payLoad?.requestSubmittedToTradeOwner,
      key: ["requestSubmittedToTradeOwner"],
    },
  ];

  // Only add execution period filter if there are actual dates
  console.log("Mukun Payload", payLoad);
  if (payLoad?.executionPeriod && (payLoad.executionPeriod[0] || payLoad.executionPeriod[1])) {
    filterArray.push({
      value: payLoad.executionPeriod,
      key: ["requestExecutedOn"],
    });
  }

  const res = filterRes(storeTableData, filterArray);
  setRquestTableData(res);
  };
  const handleReloadAPI = () => {
    setIsClearFilter(true);
    getRquestDetails(mainPayload).then(() => {
      setIsClearFilter(false);
    });
  };
  const handleCreateModal = () => {
    setIsCreateRequestModalOpen(true);
  };

const [showDatePicker, setShowDatePicker] = useState(false);
const [selectedRowForDate, setSelectedRowForDate] = useState<any>(null);
const [tempSelectedDate, setTempSelectedDate] = useState<string>("");


const handleExecutionDateChange = async (id: number, dateString: string) => {
  const parseToMoment = (d: any) => {
    if (!d && d !== 0) return null;
    if (typeof d === "string" && /^\d{4}-\d{2}-\d{2}$/.test(d)) {
      const mm = moment(d, "YYYY-MM-DD", true);
      return mm.isValid() ? mm : null;
    }
    const m = moment(d);
    return m.isValid() ? m : null;
  };

  // locate row from current state
  const row = Array.isArray(rquestTableData)
    ? (rquestTableData as any[]).find((r: any) => r.id === id)
    : undefined;

  if (!row) {
    toastEmitter({ className: "customClassName", title: "Row not found" }, { type: "error" });
    return;
  }

  // enforce update only for Completed status
  if (row.statusName !== "Completed") {
    toastEmitter({ className: "customClassName", title: "Execution date can be set only for completed cases" }, { type: "error" });
    return;
  }

  // prevent editing if already executed
  if (row.requestExecutedOn) {
    toastEmitter({ className: "customClassName", title: "Execution date already set and cannot be edited" }, { type: "error" });
    return;
  }

  const picked = parseToMoment(dateString);
  if (!picked) {
    toastEmitter({ className: "customClassName", title: "Invalid date selected" }, { type: "error" });
    return;
  }

  // validate execution >= completion
  const completion = parseToMoment(row.requestSubmittedToTradeOwner) || parseToMoment(row.requestExecuted);
  if (completion && picked.isBefore(completion, "day")) {
    toastEmitter({ className: "customClassName", title: "Execution date cannot be earlier than Completion date" }, { type: "error" });
    return;
  }

  // Show confirmation popup before proceeding
  setModalConfig({
    title: "Confirm",
    message: `Are you sure you want to set the execution date to ${picked.format("DD-MMM-YYYY")} for "${row.requestName}"?`,
    onConfirm: async () => {
      setShowConfirm(false);
      
      const currentList = Array.isArray(rquestTableData) ? (rquestTableData as any[]) : [];
      const savingList = currentList.map((r: any) => (r.id === id ? { ...r, isSavingExecutionDate: true } : r));
      setRquestTableData((savingList as unknown) as never[]);

      try {
        const payload = {
          id: row.id,
          requestExecutedOn: picked.toISOString(),
          requestName: row.requestName,
          dtcoTypeId: row.dtcoTypeId,
          dtcoCategoryId: row.dtcoCategoryId,
          drivers: row.drivers,
          costImpact: row.costImpact,
          statusId: row.statusId,
          IsDeploymentUseCase: row?.deploymentUse,
          IsExceptionalCase: row?.exceptionalScenarios,
          previousRequestId: 0,
          RequestType: isCharter ? "Chartering" : "Deployment",
          completedOn: row?.requestSubmittedToTradeOwner 
            ? moment(row.requestSubmittedToTradeOwner).toISOString()
            : null,
        };

        const res = await putAPI(`dtco-api/DTCO/UpdateDTCORequest/${row?.id}`, payload);
        
        const success = res && (res > 0 || (res as any).success === true || (res as any).isSuccess === true || res === true);

        if (!success) throw new Error("Save failed");

        toastEmitter({ className: "customClassName", title: "Execution date saved successfully" }, { type: "success" });
        
        await getRquestDetails(currentPayload);
        
      } catch (err) {
        console.error("Error updating execution date:", err);
        const reverted = (Array.isArray(rquestTableData) ? (rquestTableData as any[]) : []).map((r: any) =>
          r.id === id ? { ...r, isSavingExecutionDate: false } : r
        );
        setRquestTableData((reverted as unknown) as never[]);
        toastEmitter({ className: "customClassName", title: "Failed to save execution date. Please try again." }, { type: "error" });
      }
    },
  });
  setShowConfirm(true);
};

const [datePickerPosition, setDatePickerPosition] = useState({ top: 0, left: 0 });

const handleDatePickerOpen = (row: any, event: React.MouseEvent) => {
  event.stopPropagation();
  event.preventDefault();
  
  const buttonElement = event.currentTarget as HTMLElement;
  const rect = buttonElement.getBoundingClientRect();
  
  // Get viewport dimensions for boundary checking
  const viewportHeight = window.innerHeight;
  const viewportWidth = window.innerWidth;
  const dropdownHeight = 150; // Approximate height
  const dropdownWidth = 200;
  
  // Calculate initial position relative to viewport (no need for scroll offsets with fixed positioning)
  let top = rect.top;
  let left = rect.right + 8; // 8px gap from the button
  
  // Check if dropdown would go below viewport
  if (top + dropdownHeight > viewportHeight) {
    top = rect.bottom - dropdownHeight;
  }
  
  // Check if dropdown would go beyond right edge
  if (left + dropdownWidth > viewportWidth) {
    left = rect.left - dropdownWidth - 8; // Position to the left of button
  }
  
  // Ensure it doesn't go beyond left edge
  if (left < 8) {
    left = 8;
  }
  
  // Ensure it doesn't go above viewport
  if (top < 8) {
    top = 8;
  }
  
  setDatePickerPosition({
    top: top,
    left: left
  });
  
  setSelectedRowForDate(row);
  const parseToMoment = (d: any) => {
    if (!d && d !== 0) return null;
    const m = moment(d);
    return m.isValid() ? m : null;
  };
  
  const execMoment = parseToMoment(row.requestExecutedOn) || parseToMoment(row.requestExecuted) || null;
  setTempSelectedDate(execMoment ? execMoment.format("YYYY-MM-DD") : "");
  setShowDatePicker(true);
};


// Close dropdown when clicking outside
useEffect(() => {
  const handleClickOutside = (event: MouseEvent) => {
    if (showDatePicker && !(event.target as Element).closest('.date-picker-dropdown')) {
      handleDatePickerCancel();
    }
  };

  document.addEventListener('mousedown', handleClickOutside);
  return () => {
    document.removeEventListener('mousedown', handleClickOutside);
  };
}, [showDatePicker]);

const handleDatePickerConfirm = () => {
  if (selectedRowForDate && tempSelectedDate) {
    handleExecutionDateChange(selectedRowForDate.id, tempSelectedDate);
  }
  setShowDatePicker(false);
  setSelectedRowForDate(null);
  setTempSelectedDate("");
};

const handleDatePickerCancel = () => {
  setShowDatePicker(false);
  setSelectedRowForDate(null);
  setTempSelectedDate("");
};

  
  const paginationComponentOptions = {
    selectAllRowsItem: true,
    selectAllRowsItemText: "ALL",
  };

const columns: TableColumn<DataRow>[] = [
    {
      name: "Name",
      selector: (row) => (row.requestName !== null ? row.requestName : ""),
      sortable: true,
      width: checkRoleForActionButton ? "13%" : "18%",
      cell: (row) => (
        <a
          href={RedirectionCase(
            row.id,
            row.statusName,
            userRole,
            row.isDraftRequest,
            isCharter
          )}
          aria-label="Link to DTCO calculation page"
        >
          {row.requestName}
        </a>
      ),
    },
    {
      name: isCharter ? "TCO Type" : "DTCO Type",
      cell: (row) =>
        row.dtcoTypeName !== null ? (
          <span className="tooltipvalue" title={row.dtcoTypeName}>
            {row.dtcoTypeName}
          </span>
        ) : (
          "--"
        ),
      sortable: true,
      width: checkRoleForActionButton ? "10%" : "14%",
    },
    {
      name: isCharter ? "Selection Drivers" : "DTCO Category",
      cell: (row) =>
        row.dtcoCategoryName !== null ? (
          <span className="tooltipvalue" title={row.dtcoCategoryName}>
            {row.dtcoCategoryName}
          </span>
        ) : (
          "--"
        ),
      sortable: true,
      width: checkRoleForActionButton ? (isCharter ? "10%" : "8%") : (isCharter ? "14%" : "12%"),
    },
    {
      name: isCharter ? "Comments" : "Drivers",
      cell: (row) =>
        row.drivers !== null ? (
          row.drivers !== "" ? (
            <div title={row.drivers}>
              {" "}
              <Tooltip
                appearance="default"
                content={
                  <span>
                    <em>I am tooltip</em>
                  </span>
                }
                position="top"
                width="auto"
              >
                <span className="tooltipvalue">{row.drivers}</span>
              </Tooltip>
            </div>
          ) : (
            "--"
          )
        ) : (
          "--"
        ),
      sortable: false,
      width: checkRoleForActionButton ? (isCharter ? "12%" : "10%") : (isCharter ? "16%" : "14%"),
    },
    {
      name: "Created By",
      cell: (row) =>
        row.createdBy !== null ? (
          <span className="tooltipvalue" title={row.createdBy}>
            {row.createdBy}
          </span>
        ) : (
          "--"
        ),
      sortable: true,
      width: checkRoleForActionButton ? "10%" : "15%",
    },
    {
      name: "Total Cost Impact",
      cell: (row) =>
        row.costImpact !== null ? (
          <span className="tooltipvalue" title={row.costImpact}>
            {row.costImpact}
          </span>
        ) : (
          "--"
        ),
      sortable: true,
      width: checkRoleForActionButton ? "8%" : "13%",
    },
    {
      name: "Completion",
      cell: (row) =>
        row.requestSubmittedToTradeOwner !== null ? (
          <span
            className="tooltipvalue"
            title={fetchDateFormat(row.requestSubmittedToTradeOwner)}
          >
            {" "}
            {fetchDateFormat(row.requestSubmittedToTradeOwner)}
          </span>
        ) : (
          "--"
        ),
      sortable: true,
      width: checkRoleForActionButton ? "8%" : "12%",
      hide: isCharter ? 2299 : 0,
    },
    {
  name: "Execution",
  cell: (row) => {
    // Parse helper function
    const parseToMoment = (d: any) => {
      if (!d && d !== 0) return null;
      const m = moment(d);
      if (m.isValid()) return m;
      const mNum = moment(Number(d));
      return mNum.isValid() ? mNum : null;
    };

    // Check for execution date in the correct field (requestExecutedOn is what we save)
    const execMoment = parseToMoment(row.requestExecutedOn) || parseToMoment(row.requestExecuted) || null;

    // Show calendar input only for Completed status and if requestExecutedOn is not set
    if (row.statusName === "Completed") {
      const isAlreadyExecuted = !!row.requestExecutedOn;
      
      if (isAlreadyExecuted) {
        // Show read-only formatted date when already executed
        return execMoment ? (
          <span className="tooltipvalue" title={execMoment.format("DD-MMM-YYYY")}>
            {execMoment.format("DD-MMM-YYYY")}
          </span>
        ) : (
          "--"
        );
      } else {
        // Show calendar button with date when not yet executed
        return (
          <div className="execution-cell" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <span className="tooltipvalue">
              {execMoment ? execMoment.format("DD-MMM-YYYY") : ""}
            </span>
            <Button
              appearance="default"
              className="calendar-icon-btn xs-btn"
              id={`calendar-btn-${row.id}`}
              icon="calendar"
              justifyItems="center"
              name="OpenCalendar"
              fit="small"
              onClick={(event) => handleDatePickerOpen(row, event)}
              variant="outlined"
              aria-label={`Open calendar for ${row.requestName}`}
            />
          </div>
        );
      }
    }

    // For non-completed rows, show formatted date or placeholder
    return execMoment ? (
      <span className="tooltipvalue" title={execMoment.format("DD-MMM-YYYY")}>
        {execMoment.format("DD-MMM-YYYY")}
      </span>
    ) : (
      "--"
    );
  },
  sortable: true,
  width: checkRoleForActionButton ? "8%" : "12%",
  hide: isCharter ? 2299 : 0,
},
    {
      name: "Executed",
      selector: (row) =>
        row.requestExecuted !== null ? row.requestExecuted : "--",
      sortable: true,
      width: checkRoleForActionButton ? "6%" : "10%",
      hide: isCharter ? 2299 : 0,
    },
    {
      name: "Status",
      cell: (row) => (
        <StatusBadge
          status={row.statusName}
          diploymentUse={row.isDeploymentUseCase}
        />
      ),
      sortable: true,
      width: checkRoleForActionButton ? "10%" : "14%",
    },
    // Only include Action column when user has permission
    ...(checkRoleForActionButton ? [{
      name: "Action",
      cell: (row) => editButtonHandler(row),
      sortable: true,
      width: "12%",
      right: false,
    }] : []),
  ];

  const downloadExcel = () => {
    const dataSource: any[] = rquestTableData?.map((e: any) => {
      return {
        requestName: e.requestName,
        dtcoTypeName: e.dtcoTypeName,
        dtcoCategoryName: e.dtcoCategoryName,
        drivers: e.drivers,
        createdBy: e.createdBy,
        createdOn:
          e.createdOn != null ? moment(e.createdOn).format("DD-MMM-YYYY") : "",
        costImpact: e.costImpact,
        requestSubmittedToTradeOwner:
          e.requestSubmittedToTradeOwner != null
            ? moment(e.requestSubmittedToTradeOwner).format("DD-MMM-YYYY")
            : "",
        requestExecuted: e.requestExecuted,
        statusName: e.statusName,
      };
    });

    const header = [
      "Request Name",
      isCharter ? "Tco Type" : "Dtco Type Name",
      isCharter ? "Tco Category Name" : "Dtco Category Name",
      "Drivers",
      "Created By",
      "Created On",
      "Cost Impact",
      "Request Submitted on",
      "Request Executed",
      "Status Name",
    ];

    excelDownload("Request_Data", dataSource, header, isCharter);
  };
  const tittleList = {
    title: "Vessel Selection Tool",
  };
  return (
    <div className="request-page p-3 ">
      <h1 className="header-text">
        {" "}
        {isCharter ? "Vessel Selection Tool" : "DTCO Request Page"}{" "}
      </h1>
      {((userRole === appRoles.DeploymentUser) ||
        (userRole === appRoles.CharteringManager)) && isCharter && (
          <div className="action-items">
            <Button
              appearance="alt"
              id="btnCreateRequest"
              icon="plus"
              justifyItems="center"
              label={isCharter ? "Initiate Comparison" : "Create Request"}
              name="CreateRequest"
              fit="small"
              onClick={handleCreateModal}
              variant="primary"
            />
          </div>
        )}
      {(userRole === appRoles.DeploymentUser) && !isCharter && (
        <div className="action-items">
          <Button
            appearance="alt"
            id="btnCreateRequest"
            icon="plus"
            justifyItems="center"
            label={"Create Request"}
            name="CreateRequest"
            fit="small"
            onClick={handleCreateModal}
            variant="primary"
          />
        </div>
      )}
      <Accordian
        className="justify-content-center mb-1 accordian-filter"
        fit="small"
        size="small"
        onCardToggle={() => {
          setAccordian({ filter: !accordion.filter });
        }}
        expanded={accordion.filter}
        variant="vanity"
      >
        <Filters
          filterData={filterData}
          applyFilters={getFilteredRequestDetails}
          clearFilters={ClearFilters}
          isClearFilter={isClearFilter}
          isCharter={isCharter}
        />
      </Accordian>

      <div className="d-flex justify-content-between align-items-end mb-2">
  <Typography variant="h6">Proposal Overview</Typography>
  <div className="d-flex gap-2 align-items-end">
    <Controller
      name="searchText"
      control={control}
      defaultValue=""
      render={({ field: { onChange, value } }) => (
        <Input
          className="custom-input-width"
          type="text"
          variant="default"
          id="textInput"
          fit="small"
          value={value}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            onChange(e);
            handleSearch(e.target.value);
          }}
          placeholder="Search request name..."
        />
      )}
    />
    <Button
      appearance="default"
      id="export-excel"
      icon="tray-arrow-down"
      justifyItems="center"
      label="Extract Table"
      name="Excel"
      fit="medium"
      iconPosition="right"
      onClick={downloadExcel}
      variant="outlined"
      className="nowrap-btn"
    />
  </div>
</div>
      <div className="table-section">
        <DataTable
          columns={columns}
          data={rquestTableData}
          progressPending={isTableLoader}
          progressComponent={<SkeletonLoader isLoader={true}></SkeletonLoader>}
          pagination
          paginationComponentOptions={paginationComponentOptions}
        />
      </div>
      <CreateRequest
        isOpen={isCreateRequestModalOpen}
        dropDownData={filterData}
        reloadAPI={handleReloadAPI}
        isCharter={isCharter}
        onClose={() => setIsCreateRequestModalOpen(false)}
      />
      <EditDtcoRequest
        dropDownData={filterData}
        rowData={editRow}
        open={editModal}
        isCharter={isCharter}
        reloadAPI={handleReloadAPI}
        onClose={() => setEditModal(false)}
        actionType={actionType}
      />
     {showDatePicker && selectedRowForDate && (
        <div 
          className="date-picker-dropdown"
          style={{
            top: `${datePickerPosition.top}px`,
            left: `${datePickerPosition.left}px`,
          }}
        >
          <div className="date-picker-title">
            Select Execution Date
          </div>
          <div className="date-picker-subtitle">
           Case Owner: {selectedRowForDate?.requestName}
          </div>
          
          <input
            type="date"
            value={tempSelectedDate}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => 
              setTempSelectedDate(e.target.value)
            }
            className="date-picker-input"
          />
          
          <div className="date-picker-actions">
            <Button
              appearance="default"
              label="Cancel"
              onClick={handleDatePickerCancel}
              variant="outlined"
              fit="small"
            />
            <Button
              appearance="alt"
              label="save"
              onClick={handleDatePickerConfirm}
              variant="primary"
              fit="small"
              disabled={!tempSelectedDate}
            />
          </div>
        </div>
      )}
    </div>
  );
};
export default RequestPage;
